import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CreditCardService {
  constructor(private http: HttpClient) {}

  getCreditCardData(formsId: number): Observable<any> {
    return this.http.get(
      `${environment.api_guia}forms/${formsId}/credit-cards`
    );
  }

  updateCreditCardData(
    formsId: number,
    creditCardId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/credit-cards/${creditCardId}`,
      data
    );
  }
}
